var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.filteredMenus),function(menu){return _c('div',{key:menu.uri,staticClass:"sub-menu-item",class:{
      show: _vm.defaultRoute.menu === menu.uri,
      showMobile: _vm.defaultRoute.menuMobile === menu.uri,
    }},[_c('b-container',{staticClass:"sub-menu-container"},[_c('ul',_vm._l((menu.children),function(item){return _c('li',{key:item.uri},[(!item.dropdown)?_c('a',{class:_vm.defaultRoute.submenu === item.uri ? 'active' : '',attrs:{"href":_vm.link(menu.uri, item.uri, !!item.frontendv2)},on:{"click":function($event){return _vm.handleSelectMenu({
                menu: menu.uri,
                submenu: item.uri,
                v2: !!item.frontendv2,
              })}}},[_vm._v(" "+_vm._s(item.name)+" ")]):_c('NavbarSubMenuDropDown',{attrs:{"menu":item}})],1)}),0)])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }